import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveIsPainSort, deleteActivePainSort, setActiveIsPainSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopIsPain = ({ location, currentQuery, setCurrentQuery, pains, getSortParams, isHome, isPhysio }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-isPain button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.isPain) {
        let isPain = query.isPain.split('_');
        isPain.map(size => {
            var element = document.getElementById("isPain_"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.isPain) {
            return query.isPain + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome && currentQuery.genders && 
                    isPhysio && currentQuery.genders == "Women" ? "Est-elle blessée ?" :
                    isPhysio ? "Est-il blessé ?" :
                    currentQuery.genders == "Women" ? "Présente t'elle une douleur ?" :
                    isHome ? "Présente t'il une douleur ?" : "Avec douleur:"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-isPain mt-10" style={{display: 'block'}}>
                        {pains ? (
                            <ul>
                                {pains.map((pain, key) => {
                                    return (
                                        <li key={"isPain_"+key}>
                                            <button
                                                className="toto"
                                                id={"isPain_"+pain}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("isPain", "");
                                                        setCurrentQuery({ ...currentQuery, isPain: ""});
                                                        deleteActiveIsPainSort(e);
                                                    } else {
                                                        getSortParams("isPain", pain);
                                                        setCurrentQuery({ ...currentQuery, isPain: pain, pains: pain == "Non" ? "Pas de douleur" :"", types: "", analysis: ""});
                                                        setActiveIsPainSort(e);
                                                    }
                                                }}
                                            >
                                                {t(pain.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome && currentQuery.genders && 
                    isPhysio && currentQuery.genders == "Women" ? "Est-elle blessée ?" :
                    isHome && isPhysio ? "Est-il blessé ?" :
                    currentQuery.genders == "Women" ? "Présente t'elle une douleur ?" :                    
                    isHome ? "Présente t'il une douleur ?" : 
                    isPhysio ? "Avec blessure ?" :
                    "Avec douleur :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-isPain mt-10">
                        {pains ? (
                            <ul>
                                {pains.map((pain, key) => {
                                    return (
                                        <li key={"isPain_"+key}>
                                            <button
                                                className="toto"
                                                id={"isPain_"+pain}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("isPain", "");
                                                        setCurrentQuery({ ...currentQuery, isPain: ""});
                                                        deleteActiveIsPainSort(e);
                                                    } else {
                                                        getSortParams("isPain", pain);
                                                        setCurrentQuery({ ...currentQuery, isPain: pain, pains: pain == "Non" ? "Pas de douleur" :"", types: "", analysis: "", shoeDistance :"",});
                                                        setActiveIsPainSort(e);
                                                    }
                                                }}
                                            >
                                                {t(pain.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function ConstructRemovePainQueryPath(query, sizeToRemove) {
    if (query && query.pains) {
        let pains = query.pains.split('_');
        pains = pains.filter(size => {
            return size !== sizeToRemove;
        })
        if (pains.length > 0) {
            let newSizeQuery = ""
            pains.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopIsPain.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopIsPain;
